<template>
    <panel>
        <div class="d-flex flex-column gap-1">
            <div>
                <router-link :to="{name: 'approvals'}" active-class="fw-bold">
                    {{t('approvals')}}
                </router-link>
            </div>

            <div v-if="display.delegate">
                <router-link :to="{name: 'approvals.delegate'}" active-class="fw-bold">
                    {{t('delegates')}}
                </router-link>
            </div>

            <div v-if="display.employees">
                <router-link :to="{name: 'approvals.employees'}" active-class="fw-bold">
                    {{t('employees')}}
                </router-link>
            </div>
        </div>
    </panel>
</template>

<script>
    import Panel from "@/components/Panel.vue";

    export default {
        name: "ApprovalsMenu",
        components: {
            Panel
        },
        data() {

            return {
                t_path: "components.approvals.menu",
            }
        },
        computed: {
            display() {

                return {
                    delegate: this.$store.getters["config/user/delegate/enabled"],
                    employees: 1 == process.env.VUE_APP_ENABLED_APPROVAL_EMPLOYEES
                };
            }
        },
    }
</script>

<style scoped lang="scss">

</style>